/**
 * Centralized query keys for TanStack Query.
 * Use for consistent cache keys and invalidation.
 */

export const queryKeys = {
  campaigns: {
    all: ['campaigns'],
    /** tenantKey: acting tenant or URL tenant so lists refetch when X-Tenant changes */
    list: (clientId, tenantKey = '') => ['campaigns', 'list', clientId, tenantKey],
    detail: (id) => ['campaigns', 'detail', id],
  },
  influencers: {
    all: ['influencers'],
    /** tenantSlug (or null) avoids stale cache when X-Tenant is applied after login */
    list: (campaignId, clientId, tenantSlug = null, accountStatus = 'active') =>
      ['influencers', 'list', campaignId, clientId, tenantSlug, accountStatus],
  },
  content: {
    all: ['content'],
    list: (campaignId) => ['content', 'list', campaignId],
  },
  contentVault: {
    all: ['contentVault'],
    list: (filters = {}) => ['contentVault', 'list', filters],
  },
  clients: {
    all: ['clients'],
    /** tenantKey: same as campaigns — avoids stale empty cache after acting tenant is applied */
    list: (tenantKey = '') => ['clients', 'list', tenantKey],
    detail: (id) => ['clients', 'detail', id],
  },
  stats: {
    all: ['stats'],
    betaHealth: ['stats', 'beta-health'],
  },
  proposedInfluencers: {
    list: (campaignId) => ['proposedInfluencers', 'list', campaignId],
  },
  influencerAssignments: {
    all: ['influencerAssignments'],
  },
  tenants: {
    all: ['tenants'],
    detail: (id) => ['tenants', 'detail', id],
  },
  superAdmins: {
    all: ['superAdmins'],
  },
  /** Super-admin only: cross-tenant directory */
  platform: {
    clients: (search = '') => ['platform', 'clients', search],
    influencers: (search = '') => ['platform', 'influencers', search],
    users: (search = '', role = '') => ['platform', 'users', search, role],
    people: (filters = {}) => ['platform', 'people', filters],
    person: (id) => ['platform', 'people', id],
    deletionImpact: (userId) => ['platform', 'users', userId, 'deletion-impact'],
    storageUsage: (from = '', to = '') => ['platform', 'storage-usage', from, to],
    tenantCosts: (from = '', to = '') => ['platform', 'tenant-costs', from, to],
    hygiene: (filters = {}) => ['platform', 'hygiene', filters],
  },
}
